import React, { useEffect } from 'react';
import './paymentProcessing.css';
import { makePaymentPayNowApi } from '_services';
import toast from 'react-hot-toast';
import { addTransationFreight } from 'features';
import { useDispatch } from 'react-redux';
import { addPaymentGenExpApi, addTransationFreightForPayNow } from '_services/accountingServices/accountingServices';

const PaymentProcessingOffcanvas = ({ isOpen, message = "Please wait while we process your transaction...", paymentResult = () => { }, onClose, eaesbuzzId }) => {

    // useEffect(()=>{
    //     setTimeout(()=>{
    //       paymentResult()
    //     },2000)
    // },[])

    const dispatch = useDispatch();

    useEffect(() => {
        makePaymentHandle()
    }, [isOpen])

    const makePaymentHandle = async () => {
        try {
            // Prepare payloads
            const payload = {
                voucher_id: isOpen?.easebuzzDetails?._id,
                payment_mode: isOpen?.selectedMethod
            };

            const directPayload = {
                ...eaesbuzzId?.payload,
                eb_payment_mode: isOpen?.selectedMethod,
                eb_account_id: isOpen?.easebuzzDetails?.eb_account_id
            };

            // Determine if vendor bank account exists
            const hasVendorBankAccount = eaesbuzzId?.payload?.vendor_bank_account;

            // Call appropriate API
            const res = hasVendorBankAccount
                ?  directPayload?.expense_id ? await addPaymentGenExpApi(directPayload) : await addTransationFreightForPayNow(directPayload)
                : await makePaymentPayNowApi(payload);

                console.log("res",res)

            // Check response
            const responseCode = res?.responseCode || res?.payload?.responseCode;
            console.log(res)
            if (responseCode === 200) {
                console.log("res?.payload", hasVendorBankAccount, res?.data?.voucher_id)
                const responseData = hasVendorBankAccount ? res?.data : res?.data;
                const voucherId = hasVendorBankAccount ? res?.data?.voucher_id : isOpen?.easebuzzDetails?._id;

                console.log(voucherId, res?.data?.voucher_id, isOpen?.easebuzzDetails?._id)

                // Call payment result
                paymentResult({
                    data: responseData,
                    voucher_id: voucherId
                });
            } else {
                toast.error(res?.message || "Payment failed");
                onClose();
            }

        } catch (error) {
            console.error('Payment Error:', error);
            toast.error(error?.message || "Something went wrong");
            onClose();
        }
    };

    return (
        <div>
            <div
                className={`offcanvas offcanvas-end common_offCanvas ${isOpen ? "show" : ""}`}
                tabIndex={-1}
                style={{
                    visibility: isOpen ? "visible" : "hidden",
                }}
            >
                {isOpen && (
                    <div className="processing-offcanvas-body">
                        {/* Spinning Loader */}
                        <div className="processing-loader">
                            <div className="proccess_spinner"></div>
                        </div>

                        {/* Title */}
                        <h2 className="processing-title">Processing Payment</h2>

                        {/* Message */}
                        <p className="processing-message">{message}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PaymentProcessingOffcanvas;